import {
    Alert,
    Button,
    Card,
    CardBody,
    CardHeader,
    Col,
    Container,
    Form,
    FormGroup,
    Input,
    InputGroup,
    InputGroupAddon,
    Label,
    Row,
    Spinner,
} from "reactstrap";
import {useEffect, useState} from "react";
import {doc, getDoc, updateDoc} from "firebase/firestore";
import {useHistory, useParams} from "react-router-dom";
import {deleteObject, getDownloadURL, getStorage, ref, uploadBytes} from "firebase/storage";

import {getDb} from "../../util/Constants";
import "../../assets/css/editMiniGame.css";

const template2 = [
    {
        name: "5 Options A",
        optionsCount: 5,
        backgroundImageURL: "/5OptionsA.png"
    },
    {
        name: "5 Options B",
        optionsCount: 5,
        backgroundImageURL: "/5OptionsB.png"
    },
    {
        name: "5 Options C",
        optionsCount: 5,
        backgroundImageURL: "/5OptionsC.png"
    },
    {
        name: "8 Options",
        optionsCount: 8,
        backgroundImageURL: "/8Options.png"
    }

];

export default function EditQuestion(props) {
    const [imageFile, setImageFile] = useState(null);
    const [backgroundImageURL, setBackgroundImageURL] = useState(null);
    const [questionNumber, setQuestionNumber] = useState(1);
    const [question, setQuestion] = useState("");
    const [correctAnswer, setCorrectAnswer] = useState(0);
    const [miniGameOption, setMiniGameOption] = useState("Mini 1");
    const [templateType, setTemplateType] = useState(1);
    const [description, setDescription] = useState("");
    const [options, setOptions] = useState([""]);
    const [loading, setLoading] = useState(null);
    const [allowSave, setAllowSave] = useState(true);
    const { lName, questionIndex } = useParams();
    const [error, setError] = useState(null);
    const [template2Type, setTemplate2Type] = useState("")
    const [tem2Option, setTem2Option] = useState({})
    const [load, setLoad] = useState(false);
    const [optionsType, setOptionsType] = useState('text');
    const [backupOptions, setBackupOptions] = useState([]);
    const [mini4Options, setMini4Options] = useState(3);


    const history = useHistory();

    const db = getDb();
    let imageURL = null;
    useEffect(() => {
        (async () => await fetchMiniGameDetails())();
        return () => {
        };
    }, []);

    useEffect(() => {
        const data = template2.find((e) => e.name === template2Type);
        setTem2Option(data)
    }, [template2Type])


    const fetchMiniGameDetails = async () => {
        try {
            setLoading("data")

            const docRef = doc(getDb(), "questions", questionIndex);
            let arr = [];

            const querySnapshot = await getDoc(docRef);

            if (querySnapshot.exists()) {
                const questionList = querySnapshot.data();

                setQuestion(questionList.question);

                if (questionList.correctAnswer)
                    setCorrectAnswer(questionList.correctAnswer);

                if (questionList.description) setDescription(questionList.description);

                if (questionList.questionNumber)
                    setQuestionNumber(questionList.questionNumber);

                if (questionList.backgroundImageURL) {
                    setBackgroundImageURL(questionList.backgroundImageURL);
                }
                if (questionList.template2Type) {
                    setTemplate2Type(questionList.template2Type)
                }
                if (questionList?.optionsType) {
                    setOptionsType(questionList?.optionsType)
                }
                if(questionList.mini4Options){
                    setMini4Options(questionList.mini4Options)
                }
                setMiniGameOption(questionList.miniGame);

                setOptions(questionList.options);
                setBackupOptions(questionList.options)

                setTemplateType(questionList.miniGameTemplateType);
                setLoading(null)
            } else {
                throw Error("No such document!");
            }
        } catch (error) {

            setLoad(true)
        }
    };

    const handleImageUpload = async () => {
        const file = imageFile;

        const storage = getStorage();

        // Create a reference to a Firebase Storage location
        const storageRef = ref(storage, `images/Mini2Question${questionNumber}`);

        // Upload the file to the specified Firebase Storage location
        await uploadBytes(storageRef, file).then(async () => {
            // Get the download URL of the uploaded file

            await getDownloadURL(storageRef).then((url) => {
                imageURL = url;
            });
        });
    };


    const updateHandler = async (e) => {
        e.preventDefault();
        setLoading("saving");
        let imageUplaodError = false;
        try {
            if (templateType == 2 && imageFile) await handleImageUpload();
            e.preventDefault();
        } catch (error) {
            imageUplaodError = true;
            setError(`${error}`);
            setTimeout(() => {
                setError(undefined);
            }, 5000);
            setLoading(null);
        }
        if (templateType == 2) {
            if (optionsType !== "image") {
                deleteStorageOptions();
            }

        }

        let optionsFiles = [];
        if (templateType == 2) {
            await handleUpload();
            let optionsImages = await handleUpload();

            Array.apply(null, Array(tem2Option.optionsCount)).map((data, index) => {
                return optionsFiles.push(optionsImages[index])
            })
        }


        if (imageUplaodError) return;
        try {
            const questionDocRef = doc(db, "questions", questionIndex);

            let optionsTemplate1 = [];
            if (templateType == 1) {
                options.map((element, index) => {
                    if (index < 4) return optionsTemplate1.push(element);
                });
            } else {
                Array.apply(null, Array(tem2Option.optionsCount)).map((data, index) => {
                    return optionsTemplate1.push(options[index])
                })
            }

            const payload = {
                question: question,
                options: optionsType === "image" ? optionsFiles : optionsTemplate1,
                miniGame: miniGameOption,
                miniGameTemplateType: Number(templateType),
                description: description,

            };


            if (templateType == 2) {
                payload.template2Type = template2Type
                payload.optionsType = optionsType
                if (imageURL) payload.backgroundImageURL = imageURL;

            } else payload.correctAnswer = Number(correctAnswer);

            const res = await updateDoc(questionDocRef, payload);
            setLoading(null);

            history.goBack();
        } catch (error) {
            setError(`Failed to update Mini level details: ${error}`);
            setLoading(null);
            setTimeout(() => {
                setError(undefined);
            }, 5000);
        }


        setLoading(null)
    };



    async function handleUpload() {
        let uploadedFiles = [];
        const storage = getStorage();
        let index = 0
        let storageRef = "";
        for (const item of options) {
            index++
            if (typeof item === 'string') {
                uploadedFiles.push(item);
            } else {

                // const storageRef = ref(storage, `images/Mini2Question${questionNumber}option${index}`);
                if (mini4Options === "Mini 2") {
                    storageRef = ref(storage, `images/Mini2Question${questionIndex}option${index}`);
                }
                else {
                    storageRef = ref(storage, `images/Mini4Question${questionIndex}option${index}`);
                }
                // Upload the file to the specified Firebase Storage location
                const data = await uploadBytes(storageRef, item)
                // Get the download URL of the uploaded file
                let downloadUrls = await getDownloadURL(data.ref);
                uploadedFiles.push(downloadUrls)
            }
        }

        return uploadedFiles;
    }


    const addOption = () => {
        setOptions([...options, ""]);
    };

    const deleteOption = (index) => {
        setOptions(options.filter((ans, i) => index !== i));
    };


    const handleChange = (index, event) => {
        const { name, value, files } = event.target;

        let arr = [...options];
        if (options.length == 1 && options[0] == "") {
            arr = [];
        }
        if (optionsType === "image") {
            if (event.target.files[0].size <= 500000) {
                arr[index] = files[0];
            } else {
                alert("Image should be less than 500kb")
            }
        } else {
            arr[index] = value;

        }
        setOptions(arr);
    };

    const deleteStorageOptions = async () => {
        const storage = getStorage();
        let index = 0


        for (let item of options) {
            index++
            const desertRef = ref(storage, `images/Mini2Question${questionNumber}option${index}`);
            deleteObject(desertRef).then(() => {

            }).catch((error) => {

            });
        }
    }

    const handleOptionType = (e) => {
        setOptionsType(e.target.value)
    }

    const isValidUrl = (urlString) => {
        try {
            return Boolean(new URL(urlString));
        } catch (e) {
            return false;
        }
    }

    const handleMini4Images = (index, event) => {
        const { files } = event.target;
        let arr = [...options];
        if (files[0].size <= 500000) {
            arr[index] = files[0];
            setOptions(arr);
        } else {
            alert("Image should be less than 500kb.")
        }
    }

    const mini34handler = async (e) => {
        e.preventDefault();
        setLoading("saving")

        let payload = {}
        if (miniGameOption === "Mini 3") {
            payload = {
                question: question,
                miniGame: miniGameOption,
                questionNumber: questionNumber,
                

            }
            const questionDocRef = doc(db, "questions", questionIndex);

            const res = await updateDoc(questionDocRef, payload);
            history.goBack()


            // const docRef = await addDoc(collection(getDb(), "questions"), payload);

            setLoading(null)
        } else if (miniGameOption==="Mini 4") {
            const imagesUpload = await handleUpload()
            let optionsFiles=[]
            Array.apply(null, Array(parseInt(mini4Options))).map((data, index) => {
                return optionsFiles.push(imagesUpload[index])
            })


            payload = {
                question: question,
                miniGame: miniGameOption,
                questionNumber: questionNumber,
                options: optionsFiles,
                mini4Options:mini4Options
            }
            const questionDocRef = doc(db, "questions", questionIndex);
            const res = await updateDoc(questionDocRef, payload);

            // history.push(`/admin/levels/${lName}`);
            history.goBack()

            // const docRef = await addDoc(collection(getDb(), "questions"), payload);

            setLoading(null)

        }


    }




    return (
        <>
            <div className="header  pb-8 pt-5 pt-md-8" />
            <Container className="mt--9" fluid>
                {
                    <Row className="mb-4">
                        <Col>
                            <Card className="shadow">
                                <CardHeader className="d-flex justify-content-between align-items-center">
                                    <h2 className="mb-0">Edit Screen</h2>
                                </CardHeader>
                                {miniGameOption === "Mini 1" || miniGameOption === "Mini 2" ? <CardBody>
                                    {
                                        error &&
                                        <Alert color="danger">
                                            {error}
                                        </Alert>
                                    }
                                    {loading === "data" ? (
                                        <div className="text-center py-5 mt-5">
                                            <Spinner color="primary" />
                                        </div>
                                    ) : (
                                        <Form onSubmit={updateHandler}>

                                            <Row>
                                                {templateType === 2 &&

                                                    <>

                                                        <Col md="6" className="mb-4">
                                                            <h3 className="mb-3">Select Template</h3>
                                                            <div>

                                                                <FormGroup>
                                                                    <Input
                                                                        onChange={(e) => setTemplate2Type(e.target.value)}
                                                                        value={template2Type}
                                                                        className="form-control-alternative"
                                                                        type="select"
                                                                        name="template2Options"
                                                                        id="exampleSelect"
                                                                    >
                                                                        {template2.map((e) => (
                                                                            <option key={e.name} value={e.name}>
                                                                                {e.name}
                                                                            </option>
                                                                        ))}
                                                                    </Input>
                                                                </FormGroup>

                                                            </div>
                                                        </Col>

                                                        <Col md={"6"} className={"mb-4"}>
                                                            <div className={"containerss"}>
                                                                <a download={tem2Option.name + ".png"}
                                                                    href={tem2Option.backgroundImageURL}
                                                                    title={tem2Option.name}>
                                                                    <img
                                                                        src={
                                                                            tem2Option.backgroundImageURL}
                                                                        style={{
                                                                            height: "150px",
                                                                            objectFit: "contain",
                                                                            borderRadius: "5px"
                                                                        }}
                                                                        alt="Selected Image"
                                                                    />

                                                                    <div className="overlay">Download</div>
                                                                </a>
                                                            </div>
                                                        </Col>


                                                        <Col md="12" className="mb-2">
                                                            <div>
                                                                <h3 className="mb-2">Upload Your background Image <span
                                                                    style={{ fontSize: "12px" }} className="text-muted">(Image should be 1920px x 1080px)</span>
                                                                </h3>
                                                                <FormGroup>
                                                                    <label htmlFor="imageUpload"
                                                                        className={`btn btn-sm  mb-1 ${imageFile ? "btn btn-success" : "btn btn-primary"}`}>
                                                                        <i className="fa fa-upload mr-2" />
                                                                        {imageFile ? "Image Selected" : "Upload Image"}
                                                                    </label>

                                                                    <input
                                                                        type="file"
                                                                        id="imageUpload"
                                                                        accept="image/*"
                                                                        onChange={(e) => {
                                                                            const file = e.target.files[0];
                                                                            const allowedTypes = ["image/jpeg", "image/png"];
                                                                            if (file.size <= 1000000) {
                                                                                if (file && allowedTypes.includes(file.type)) {
                                                                                    setImageFile(e.target.files[0]);

                                                                                    const reader = new FileReader();
                                                                                    reader.readAsDataURL(file);
                                                                                    reader.onload = () => {
                                                                                        setBackgroundImageURL(reader.result);
                                                                                    };
                                                                                } else {
                                                                                    setError("Please upload an image file in jpeg/png format only. Other formats are not allowed.");
                                                                                    setTimeout(() => {
                                                                                        setError(undefined);
                                                                                    }, 5000);
                                                                                }
                                                                            } else {
                                                                                alert("Image should be of 1mb")
                                                                            }

                                                                        }}
                                                                        style={{ display: "none" }}
                                                                    />

                                                                    {imageFile || backgroundImageURL ? (
                                                                        <div className="mt-3">
                                                                            <img
                                                                                src={backgroundImageURL ?? imageFile}
                                                                                style={{
                                                                                    height: "150px",
                                                                                    objectFit: "contain",
                                                                                    border: "1px solid #ddd",
                                                                                    borderRadius: "5px"
                                                                                }}
                                                                                className="img-fluid"
                                                                                alt="Selected Image"
                                                                            />
                                                                        </div>
                                                                    ) : (
                                                                        <div className="text-muted mt-3">No image
                                                                            selected</div>
                                                                    )}
                                                                </FormGroup>
                                                            </div>
                                                        </Col>
                                                    </>}


                                                <Col md="6" className="mb-4">
                                                    <div>
                                                        <h3 className="mb-3">Title</h3>
                                                        <FormGroup>
                                                            <Input
                                                                type="textarea"
                                                                id="description"
                                                                value={description}
                                                                maxLength="250"
                                                                rows={5}
                                                                required
                                                                className="form-control-alternative"
                                                                onChange={(e) => setDescription(e.target.value)}
                                                            />
                                                        </FormGroup>
                                                    </div>
                                                </Col>
                                                <Col md="6" className="mb-4">
                                                    <div>
                                                        <h3 className="mb-3">Scenario</h3>
                                                        <FormGroup>
                                                            <Input
                                                                type="textarea"
                                                                id="question"
                                                                rows={5}
                                                                required
                                                                value={question}
                                                                className="form-control-alternative"
                                                                onChange={(e) => setQuestion(e.target.value)}
                                                                maxLength="400"
                                                                onInput={(object) => {
                                                                    if (object.target.value.length > object.target.maxLength)
                                                                        object.target.value = object.target.value.slice(0, object.target.maxLength);
                                                                }}
                                                            />
                                                        </FormGroup>
                                                    </div>
                                                </Col>


                                            </Row>


                                            {templateType == 1 ? (
                                                <Row>
                                                    <Col xs={12}>
                                                        <div className="d-flex justify-content-between">
                                                            <h3 className="mb-0">Options</h3>

                                                        </div>
                                                        <hr className="mt-3" />
                                                    </Col>
                                                    {options.map((data, index) => {
                                                        if (index < 4)
                                                            return (
                                                                // <Col lg={12}>

                                                                <Col lg={6}>
                                                                    <div className="p-3 border rounded mb-4 bg-lighter">
                                                                        <Row>
                                                                            <Col lg={12}>
                                                                                <FormGroup>
                                                                                    <div
                                                                                        className="d-flex justify-content-between mb-2">
                                                                                        <Label
                                                                                            for="optionText"
                                                                                            className="col-8"
                                                                                        >
                                                                                            {` Option ${index + 1} `}
                                                                                        </Label>

                                                                                        <input
                                                                                            className="checkmarkMiniGameEdit"
                                                                                            type="radio"
                                                                                            id="html"
                                                                                            name="fav_language"
                                                                                            checked={
                                                                                                correctAnswer === index
                                                                                            }
                                                                                            value={index}
                                                                                            onChange={(e) => {
                                                                                                setAllowSave(true);
                                                                                                setCorrectAnswer(index);
                                                                                            }}
                                                                                        />
                                                                                        <Label for="optionText">
                                                                                            {`Correct Answer`}
                                                                                        </Label>


                                                                                    </div>
                                                                                    <Input
                                                                                        rows={10}
                                                                                        type="text"
                                                                                        id="optionText"
                                                                                        value={data}
                                                                                        maxLength="70"
                                                                                        required
                                                                                        name="option"
                                                                                        className="form-control-alternative"
                                                                                        onChange={(event) =>
                                                                                            handleChange(index, event)
                                                                                        }
                                                                                    />
                                                                                </FormGroup>
                                                                            </Col>
                                                                        </Row>
                                                                    </div>
                                                                </Col>
                                                            );
                                                    })}
                                                </Row>
                                            ) : (
                                                <Row>
                                                    <Col xs={"6"}>
                                                        <h3 className="mb-0">Select Options type</h3>
                                                        <FormGroup>
                                                            <Input onChange={handleOptionType}
                                                                value={optionsType}
                                                                className="form-control-alternative"
                                                                type="select"
                                                                name="template2Options"
                                                                id="exampleSelect">
                                                                <option value={"text"}>{"Text"}</option>
                                                                <option value={"image"}>{"Image"}</option>

                                                            </Input>
                                                        </FormGroup>
                                                    </Col>
                                                    <Col xs={12}>
                                                        <div className="d-flex justify-content-between">
                                                            <h3 className="mb-0"> Options in correct order</h3>
                                                        </div>
                                                        <hr className="mt-3" />
                                                    </Col>
                                                    {Array.apply(null, Array(tem2Option.optionsCount)).map((data, index) => (
                                                        <Col lg={6}>
                                                            <div className="p-3 border rounded mb-4 bg-lighter">
                                                                <Row>
                                                                    <Col lg={12}>
                                                                        <FormGroup>
                                                                            <div
                                                                                className="d-flex justify-content-between mb-2">
                                                                                <Label for="optionText">
                                                                                    {` Option ${index + 1} `}{optionsType === "image" &&
                                                                                        <span
                                                                                            style={{ fontSize: "12px" }}
                                                                                            className="text-muted">(Image should be 226px x 236px or 1 : 1)</span>}
                                                                                </Label>


                                                                            </div>
                                                                            {optionsType === "image" ?
                                                                                <label htmlFor={"imageUploads" + index}
                                                                                    className={`btn btn-sm btn-secondary mb-1 }`}>
                                                                                    Choose File
                                                                                </label> : ""} <InputGroup>

                                                                                <Input
                                                                                    type={optionsType === "text" ? "text" : "file"}
                                                                                    value={(optionsType === "text" && !isValidUrl(options[index]) && typeof options[index] !== "object") ? options[index] : null}
                                                                                    maxLength="70"
                                                                                    id={"imageUploads" + index}
                                                                                    required={optionsType === 'text'}
                                                                                    name="option"
                                                                                    className={`form-control-alternative ${optionsType === "text" ? "" : "d-none"}`}
                                                                                    onChange={(event) =>
                                                                                        handleChange(index, event)
                                                                                    }

                                                                                />

                                                                                {optionsType !== "text" ?
                                                                                    <InputGroupAddon
                                                                                        addonType="prepend">{typeof options[index] === "string" && options[index].startsWith('https') ?
                                                                                            <img className="mt-2"
                                                                                                width={100}
                                                                                                src={backupOptions[index]} /> :
                                                                                            typeof options[index] === "object" ?
                                                                                                <img className="mt-2"
                                                                                                    width={100}
                                                                                                    src={URL.createObjectURL(options[index])} /> : ""}</InputGroupAddon> : ""
                                                                                }

                                                                            </InputGroup>
                                                                        </FormGroup>
                                                                    </Col>
                                                                </Row>
                                                            </div>
                                                        </Col>
                                                    ))}
                                                </Row>
                                            )}

                                            <Row>
                                                <Col className="text-right">
                                                    <Button
                                                        color="danger"
                                                        onClick={() => history.goBack()}
                                                        disabled={loading === "saving"}
                                                    >
                                                        Cancel
                                                    </Button>

                                                    {!allowSave ? (
                                                        <Button
                                                            color="primary"
                                                            onClick={() => {
                                                                setError("correct Answer is required");
                                                                setTimeout(() => {
                                                                    setError(undefined);
                                                                }, 5000);
                                                            }}
                                                            disabled={loading === "saving"}
                                                        >
                                                            {loading === "saving" ? (
                                                                <Spinner color="light" size="sm" />
                                                            ) : (
                                                                "Save"
                                                            )}
                                                        </Button>
                                                    ) : (
                                                        <Button
                                                            color="primary"
                                                            type="submit"
                                                            disabled={loading === "saving"}
                                                        >
                                                            {loading === "saving" ? (
                                                                <Spinner color="light" size="sm" />
                                                            ) : (
                                                                "Save"
                                                            )}
                                                        </Button>
                                                    )}
                                                </Col>
                                            </Row>
                                        </Form>
                                    )}
                                </CardBody> : <CardBody>

                                    {
                                        loading === "data" ? (
                                            <div className="text-center py-5 mt-5">
                                                <Spinner color="primary" />
                                            </div>
                                        ) : (
                                            <Form onSubmit={(e) => mini34handler(e)}>
                                                <Row>

                                                    {miniGameOption === "Mini 4" && <Col xs={"3"}>
                                                        <h3 className="mb-0">Select Template</h3>
                                                        <FormGroup>
                                                            <Input onChange={(e) => setMini4Options(e.target.value)}
                                                                value={mini4Options}
                                                                className="form-control-alternative"
                                                                type="select"
                                                                name="template2Options" id="exampleSelect">
                                                                <option value={3}>Upto 3</option>
                                                                <option value={4}>Upto 4</option>
                                                                <option value={5}>Upto 5</option>
                                                                <option value={6}>Upto 6</option>
                                                                <option value={7}>Upto 7</option>
                                                            </Input>
                                                        </FormGroup>
                                                    </Col>}
                                                    {/* <Col xs={"6"}></Col> */}

                                                    <Col xs={miniGameOption === "Mini 4" ? "9" : "6"}>
                                                        <h3 className="mb-0">{miniGameOption === "Mini 3" ? "Word" : "Scenario"}</h3>
                                                        <FormGroup>
                                                            <Input onChange={(e) => setQuestion(miniGameOption === "Mini 3" ? e.target.value.trim() : e.target.value)}
                                                                value={question}
                                                                className="form-control-alternative"
                                                                rows={templateType === 3?false:10}
                                                                minLength={miniGameOption === "Mini 3" ? 4 : 400}
                                                                maxLength={miniGameOption === "Mini 3" ? 10 : 400}
                                                                type={miniGameOption === "Mini 3" ? "text" : "textarea"}
                                                                name="Question" id="exampleSelect">
                                                            </Input>
                                                        </FormGroup>
                                                    </Col>
                                                    {templateType === 4 && <Col xs={12}>
                                                        <div className="d-flex justify-content-between">
                                                            <h3 className="mb-0">Options in correct order</h3>


                                                        </div>
                                                        <hr className="mt-3" />
                                                    </Col>}

                                                    {miniGameOption === "Mini 4" && Array.apply(null, Array(parseInt(mini4Options))).map((data, index) => (
                                                        <Col lg={6} key={index}>
                                                            <div className="p-3 border rounded mb-4 bg-lighter">
                                                                <Row>
                                                                    <Col lg={12}>
                                                                        <FormGroup>
                                                                            <div className="d-flex justify-content-between mb-2">
                                                                                <Label for={`optionText${index}`}>
                                                                                    {` Option ${index + 1} `}
                                                                                </Label>
                                                                            </div>

                                                                            <label htmlFor={`imageData${index}`} className="btn btn-sm btn-secondary mb-1 d-inline-block">
                                                                                Choose File
                                                                            </label>
                                                                            <Input
                                                                                type="file"
                                                                                id={`imageData${index}`}
                                                                                value={data}
                                                                                // required
                                                                                name="option"
                                                                                className="form-control-alternative d-none"
                                                                                onChange={(event) => handleMini4Images(index, event)}
                                                                            />

                                                                            {options.length !== 0 && (
                                                                              <InputGroupAddon
                                                                              addonType="prepend">{typeof options[index] === "string" && options[index].startsWith('https') ?
                                                                                  <img className="mt-2"
                                                                                
                                                                                      width={100}
                                                                                      src={backupOptions[index]} /> :
                                                                                  typeof options[index] === "object" ?
                                                                                      <img className="mt-2"
                                                                                          width={100}
                                                                                          src={URL.createObjectURL(options[index])} /> : ""}</InputGroupAddon>
                                                                            )}
                                                                        </FormGroup>
                                                                    </Col>
                                                                </Row>
                                                            </div>
                                                        </Col>
                                                    ))}

                                                </Row>
                                                <Row>
                                                    <Col className="text-right">
                                                        <Button
                                                            color="danger"
                                                            onClick={() => history.goBack()}
                                                            disabled={loading === "saving"}
                                                        >
                                                            Cancel
                                                        </Button>
                                                        {!allowSave ? (
                                                            <Button
                                                                color="primary"
                                                                onClick={() => {
                                                                    alert("correct Answer is required");
                                                                }}
                                                                disabled={loading === "saving"}
                                                            >
                                                                {loading === "saving" ? (
                                                                    <Spinner color="light" size="sm" />
                                                                ) : (
                                                                    "Save"
                                                                )}
                                                            </Button>
                                                        ) : (
                                                            <Button
                                                                color="primary"
                                                                type="submit"
                                                                disabled={loading === "saving"}
                                                            >
                                                                {loading === "saving" ? (
                                                                    <Spinner color="light" size="sm" />
                                                                ) : (
                                                                    "Save"
                                                                )}
                                                            </Button>
                                                        )}
                                                    </Col>
                                                </Row>

                                            </Form>


                                        )
                                    }


                                </CardBody>}
                            </Card>
                        </Col>
                    </Row>
                }
            </Container>
        </>
    );
}
